/**
 * 살아있는 SM 세션 ID의 계정 단위 영속 (#286, 세션-브라우저 결합 해제
 * Phase 1).
 *
 * 현행 세션 ID는 메모리 전용이라 새로고침만으로 소실 — SM의 재부착
 * grace 안에조차 AttachSession을 시도할 수 없었다. 여기 저장된 값으로
 * 부팅 시 attach를 먼저 시도하고, 실패하면 폐기 후 새 세션을 만든다.
 *
 * 실행 스냅샷(vsmr.lastRun) 영속은 폐지됐다(2026-08-08 "복귀 개념 폐지"):
 * 기존 실행 표시는 Simulations [이어보기]가 유일한 경로이고, 그 상태는
 * resumeSession이 서버 사실(이력·SM 스냅샷)에서 직접 구성한다.
 *
 * 저장은 계정 단위(OIDC sub 포함 키) — [[lastWorkspace]]와 같은 이유(#267,
 * 계정 전환 시 승계 오염 방지).
 */

const SESSION_PREFIX = 'vsmr.lastSession';

function sessionKey(userId: string): string {
  return `${SESSION_PREFIX}.${userId}`;
}

export function getStoredSessionId(userId: string | null | undefined): string | null {
  if (!userId) return null;
  try {
    // 저장·조회 모두 trim 정규화 — 이 값은 현재 세션 ID와 동등 비교에 쓰인다
    const raw = localStorage.getItem(sessionKey(userId))?.trim();
    return raw || null;
  } catch {
    return null;
  }
}

export function setStoredSessionId(userId: string | null | undefined, sessionId: string): void {
  const trimmed = sessionId.trim();
  if (!userId || !trimmed) return;
  try {
    localStorage.setItem(sessionKey(userId), trimmed);
  } catch {
    // 저장 실패는 무해 — 다음 부팅이 새 세션을 만들 뿐
  }
}

export function clearStoredSessionId(userId: string | null | undefined): void {
  if (!userId) return;
  try {
    localStorage.removeItem(sessionKey(userId));
  } catch {
    // 무해
  }
}

/**
 * 폐지된 실행 스냅샷(vsmr.lastRun.*)의 잔존 키 청소 — 부팅 시 1회 호출.
 * 남아 있어도 무해하지만, 더 이상 읽는 코드가 없는 데이터는 지운다.
 */
export function purgeLegacyStoredRuns(): void {
  try {
    const stale: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key?.startsWith('vsmr.lastRun.')) stale.push(key);
    }
    stale.forEach((key) => localStorage.removeItem(key));
  } catch {
    // 무해
  }
}
